var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gameList"},[_c('HeadBar',{attrs:{"title":"赛事列表"}}),_c('div',{staticClass:"gameBox"},[_c('GamaList',{attrs:{"gameList":_vm.gameList}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }